import { Box, CircularProgress, CircularProgressProps } from '@mui/material';

export default function Loading(props: CircularProgressProps) {
  return (
    <Box sx={{ display: 'flex', height: '100%' }} justifyContent="center" alignItems="center">
      <CircularProgress {...props} />
    </Box>
  );
}
